// Globals
import { useTranslation } from 'react-i18next';

// Components
import { ALL_REGIONS_ROW_ID, getProductsTableColumns } from './columns';
import { Table } from '@/ui';

// Models
import { IBulkUpdateStockItem, IProductRegionsAndPricesListItem } from '@/models/products.model';

const ALL_REGIONS_SYNTHETIC_ROW: IProductRegionsAndPricesListItem = {
  id: ALL_REGIONS_ROW_ID,
  product_id: '',
  region: '',
  available: false,
  quantity: 0,
  price: '0',
  discount_price: '',
};

type TProductRegionsAndPricesListProps = {
  productsRegionsAndPrices: IProductRegionsAndPricesListItem[] | null;
  isLoading: boolean;
  isEditing: boolean;
  editedData: Map<string, IBulkUpdateStockItem>;
  onFieldChange: (id: string, field: keyof IBulkUpdateStockItem, value: boolean | number) => void;
  allRegionsPrice: number | null;
  allRegionsDiscountPrice: number | null;
  onAllRegionsFieldChange: (field: 'price' | 'discount_price', value: number | null) => void;
};

const ProductRegionsAndPricesList = ({
  productsRegionsAndPrices,
  isLoading,
  isEditing,
  editedData,
  onFieldChange,
  allRegionsPrice,
  allRegionsDiscountPrice,
  onAllRegionsFieldChange,
}: TProductRegionsAndPricesListProps) => {
  const { t } = useTranslation(['products']);
  const columns = getProductsTableColumns({
    t,
    isEditing,
    editedData,
    onFieldChange,
    allRegionsPrice,
    allRegionsDiscountPrice,
    onAllRegionsFieldChange,
  });

  const baseData = productsRegionsAndPrices || [];
  const dataSource = isEditing ? [ALL_REGIONS_SYNTHETIC_ROW, ...baseData] : baseData;

  return <Table columns={columns} dataSource={dataSource} rowKey="id" loading={isLoading} />;
};

export default ProductRegionsAndPricesList;
